import React, { FC } from 'react';
import { FieldArrayRenderProps, useFormikContext } from 'formik';
import { isEmpty, uniqueId } from 'lodash';
import { Button } from '@qbe/ads-core';
import { FormCard, Toggle } from '@qbe/ads-blocks-forms';
import { useContentContext } from '@qbe/dfc-content';

import FormSpacer from 'components/FormSpacer/FormSpacer';
import { IncomeData, IncomeFormFields } from 'contexts/FormProvider';
import { YesNoList } from 'utils/constants';
import validationSchema from '../schema';
import { useContentComplaintPartners } from 'utils/content';

interface Props {
  arrayHelpers: FieldArrayRenderProps;
}

const IncomeStatus: FC<Props> = ({ arrayHelpers }) => {
  const { values, setFieldValue, setFieldTouched, resetForm } = useFormikContext<IncomeFormFields>();

  const { getTextContent } = useContentComplaintPartners({
    context: useContentContext(),
  });

  const isDisabled = !validationSchema.isValidSync(values);

  const hasIncome = values.incomeStatus === 'yes';

  return (
    <FormCard variant="sectionTitle" title={getTextContent('Income.details.heading')}>
      <Toggle
        title={getTextContent('Income.details.incomeStatus')}
        required
        name="incomeStatus"
        optionList={YesNoList.map((option) => ({
          id: option.value,
          label: option.text,
          value: option.value,
          checked: values.incomeStatus === option.value,
          'data-track': 'incomeStatus',
          'data-track-value': 'capture',
          onBlur: () => setFieldTouched('incomeStatus', true),
          onChange: (event) => {
            const value = event.currentTarget.value;
            setFieldValue('incomeStatus', value);

            if (isEmpty(values.incomeData) && value === 'yes') {
              const newDetails: IncomeData = {
                id: uniqueId(),
                incomeType: '',
                incomeDescription: '',
                incomeAmount: '',
              };

              arrayHelpers.push(newDetails);
            }

            if (!isEmpty(values.incomeData) && value === 'no') {
              resetForm({
                errors: {
                  incomeData: [],
                  incomeStatus: '',
                },
              });

              setFieldValue('incomeData', []);
              setFieldValue('incomeStatus', value);
            }
          },
        }))}
      />

      {!hasIncome && (
        <>
          <FormSpacer type="input" />
          <Button type="submit" label={getTextContent('Income.details.submit.label')} disabled={isDisabled} />
        </>
      )}
    </FormCard>
  );
};

export default IncomeStatus;
